import { render, staticRenderFns } from "./trainingModulePageInformationVideo.vue?vue&type=template&id=07fb2692&scoped=true&"
import script from "./trainingModulePageInformationVideo.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageInformationVideo.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageInformationVideo.vue?vue&type=style&index=0&id=07fb2692&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb2692",
  null
  
)

export default component.exports